import * as yup from "yup";

export const priceIdentifierList = [
    {
        priceldentifier_id: 3,
        description: "Scheme",
        key: "SCHEME",
    },
    {
        priceldentifier_id: 1,
        description: "Discount Percent",
        key: "DISCOUNT_PERCENT",
    },
    {
        priceldentifier_id: 2,
        description: "Discount Amount",
        key: "DISCOUNT_AMOUNT",
    },
];

export const schema = yup.object({
    itemCode: yup.string().required("Item Code is required"),
    itemName: yup.string().required("Item Name is required"),
    itemPrice: yup.object().required("Item Price is required"),
    mrp: yup.number().required("MRP is required"),
    //M10-11621 - M10-11919
    price: yup
        .number()
        .required("Price is required")
        .test(
            "price-not-more-than-ptr-plus-15",
            "The price cannot exceed PTR by more than 5%.",
            function (value) {
                const ptr = Number(this.parent.ptr);
                if (!ptr || !value) return true;
                const allowedIncrease = ptr * 0.05;
                return value <= ptr + allowedIncrease;
            }
        ),
    //M10-11621 - M10-11919
    batchNo: yup.string().required("Batch No. is required"),
    // schemeType: yup.object().required("Scheme Type is required"),
    quantity: yup.number().integer().required("Quantity is required"),
    // freeQty: yup.number().integer(),
    //M10-11001
    discountPercentage: yup
        .string()
        .nullable()
        .notRequired()
        .test(
            "is-empty-or-valid",
            "Discount must be 1 or 2 digits and up to 2 decimals",
            // M10-11246
            function (value) {
                // If priceIdentifier_id is not 3, always pass (skip validation)
                if (this.parent?.schemeType?.priceldentifier_id === 3) {
                    return true;
                }
                // Allow empty values
                if (value === "" || value === null || value === undefined) return true;
                // Validate format only if applicable
                return /^(?:\d{1,2})(?:\.\d{1,2})?$/.test(value);
                // M10-11246
            }
        ),
    //M10-11001
});

//M10-11021
export function validateInvoiceNumber(invoice: any) {
    if (!invoice || invoice.trim() === "") {
        return { valid: false, error: "Invoice number cannot be empty." };
    }

    const first = invoice[0];
    const last = invoice[invoice.length - 1];
    // This regex checks for any special character EXCEPT ( and )
    const special = /[^a-zA-Z0-9()]/;

    if (special.test(first) && first !== '(' && first !== ')') {
        return { valid: false, error: "Invoice number cannot start with a special character." };
    }

    if (special.test(last) && last !== '(' && last !== ')') {
        return { valid: false, error: "Invoice number cannot end with a special character." };
    }

    return { valid: true, error: null };
}
//M10-11021